import { FilterDropdownProps } from 'antd/lib/table/interface'
import FilterDropdown from '../FilterDropdown'
import { useState } from 'react'
import { InputNumber, Row, Space } from 'antd'
import HelpIcon from 'components/HelpIcon'
import { NumberRangeFilterValue } from '../../types'

/**
 * Generate a unique id for each input field using a monotonically increasing
 * number. This ensures that each input field can be associated with its
 * respective label element, while avoiding the need to wrap everything in a
 * label, which would result in invalid HTML due to child components containing
 * <div> elements. The id will increment each time the component renders,
 * ensuring unique ids across the DOM.
 */
let id = 0

const NumberRangeFilter: React.VFC<FilterDropdownProps> = ({
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
}) => {
  const [, setSearchValue] = useState<NumberRangeFilterValue>({})
  const get = () =>
    selectedKeys[0]
      ? (JSON.parse(selectedKeys[0].toString()) as NumberRangeFilterValue)
      : {}
  const set = (key: keyof NumberRangeFilterValue, value: number | null) => {
    const next = { ...get(), [key]: value }
    if (typeof next.greater !== 'number' && typeof next.less !== 'number')
      return setSelectedKeys([])
    return setSelectedKeys([JSON.stringify(next)])
  }
  const greaterThanId = `number-range-filter-greater-${id}`
  const lessThanId = `number-range-filter-less-${id}`

  id++

  return (
    <FilterDropdown
      confirm={confirm}
      selectedKeys={selectedKeys}
      clearFilters={clearFilters}
      onOk={() => {
        const [value] = selectedKeys as unknown as [NumberRangeFilterValue]
        setSearchValue({
          greater: value?.greater ?? null,
          less: value?.less ?? null,
        })
      }}
      onReset={() => setSearchValue({})}
    >
      <Space direction="vertical" size="small" style={{ width: 300 }}>
        <Row justify="space-between" align="middle">
          <HelpIcon text="Filter for values greater than or equal to this value">
            <label htmlFor={greaterThanId}>Greater or Equal</label>
          </HelpIcon>
          <InputNumber
            id={greaterThanId}
            value={get().greater}
            style={{ width: '50%' }}
            onChange={(value) => set('greater', value)}
          />
        </Row>
        <Row justify="space-between" align="middle">
          <HelpIcon text="Filter for values less than or equal to this value">
            <label htmlFor={lessThanId}>Less or Equal</label>
          </HelpIcon>
          <InputNumber
            id={lessThanId}
            value={get().less}
            style={{ width: '50%' }}
            onChange={(value) => set('less', value)}
          />
        </Row>
      </Space>
    </FilterDropdown>
  )
}

export default NumberRangeFilter
